import React from 'react';
import { Card, Badge, Row, Col } from 'react-bootstrap';

const Section = ({ title }) => (
  <h6 className="text-uppercase fw-bold text-secondary mt-4 mb-2 border-bottom pb-1">
    {title}
  </h6>
);

const GroupProfileCard = ({ profile }) => (
  <Card className="shadow border-0 mb-5" style={{ maxWidth: '540px', width: '100%' }}>
    <Card.Body className="p-4">
      {/* Display general area based on location */}
      <h4 className="fw-bold mb-3">
        {profile.location ? `${profile.location} area` : 'Anonymous Posting'}
      </h4>
      
      <Section title="Coverage Needs" />
      <Row className="mb-2">
        <Col xs={6}><strong>Start:</strong> {profile.coverageNeeds.startDate}</Col>
        <Col xs={6}><strong>Duration:</strong> {profile.coverageNeeds.duration}</Col>
      </Row>
      <Row className="mb-2">
        <Col xs={6}><strong>Schedule:</strong> {profile.coverageNeeds.scheduleType}</Col>
        <Col xs={6}><strong>Hours/Week:</strong> {profile.coverageNeeds.estimatedWeeklyHours}</Col>
      </Row>
      <p className="mb-0">
        {profile.coverageNeeds.onCall && <Badge bg="danger" className="me-2">On-Call</Badge>}
        {profile.coverageNeeds.weekends && <Badge bg="warning" className="text-dark">Weekends</Badge>}
      </p>
      
      <Section title="Clinical Expectations" />
      <p>
        <strong>Case Types:</strong>{' '}
        {Array.isArray(profile.clinicalExpectations.requiredCaseTypes)
          ? profile.clinicalExpectations.requiredCaseTypes.join(', ')
          : profile.clinicalExpectations.requiredCaseTypes}
      </p>
      
      <Section title="Compensation" />
      <p className="mb-1"><strong>Hourly Rate:</strong> {profile.compensation.rateRange}</p>
      <p className="mb-1"><strong>Type:</strong> {profile.compensation.w2Or1099}</p>
      <p className="mb-1 text-muted">
        {profile.compensation.includesHousing && <span className="me-2">🏠 Housing</span>}
        {profile.compensation.includesTravel && <span className="me-2">✈️ Travel</span>}
        {profile.compensation.malpracticeCovered && <span className="me-2">⚖️ Malpractice</span>}
      </p>
      
      {profile.additionalNotes && (
        <>
          <Section title="Notes" />
          <p className="fst-italic text-muted">{profile.additionalNotes}</p>
        </>
      )}
    </Card.Body>
  </Card>
);

export default GroupProfileCard;
